// DO NOT EDIT THIS FILE!
// This file is autogenerated by the Parcel web application bundler.

import './app';
import '../../blocks/artist-hero/scripts/view';
import '../../blocks/event-calendar/scripts/view';
import '../../blocks/event-hero/scripts/view';
import '../../blocks/exhibition-hero/scripts/view';
import '../../blocks/grid/scripts/view';
import '../../blocks/hero/scripts/view';
import '../../blocks/post-archive/scripts/view';
import '../../blocks/read-more-button/scripts/view';
import '../../blocks/rich-text/scripts/view';
import '../../blocks/search-result/scripts/view';
import '../../blocks/selected-posts/scripts/view';
import '../../blocks/start-page-hero/scripts/view';
import '../../blocks/video/scripts/view';
import '../../blocks/more-events/scripts/view';
